import absence from "@/translations/absence/de";
import account from "@/translations/account/de";
import document from "@/translations/document/de";
import forms from "@/translations/forms/de";
import questionnaire from "@/translations/questionnaire/de";
import gradebook from "@/translations/gradebook/de";
import lesson from "@/translations/lesson/de";
import login from "@/translations/login/de";
import chat from "@/translations/chat/de";
import chatbot from "@/translations/chatbot/de";
import page from "@/translations/page/de";
import skills from "@/translations/skills/de";
import timetable from "@/translations/timetable/de";
import trainingCourse from "@/translations/training-course/de";
import triad from "@/translations/triad/de";
import platform from "@/translations/platform/de";
import admin from "@/translations/admin/de";
import studeaManager from "@/translations/studea-manager/de";
import dashboard from "@/translations/dashboard/de";
import global from "@/translations/global/de";
import error from "@/translations/error/de";
import notepad from "@/translations/notepad/de";
import registration from "@/translations/registration/de";
import training from "@/translations/training/de";
import institution from "@/translations/institution/de";
import matching from "@/translations/matching/de";
import landing from "@/translations/landing/de";
import mailStatus from "@/translations/mail-status/de";

export const de = {
  ...absence,
  ...account,
  ...document,
  ...forms,
  ...questionnaire,
  ...gradebook,
  ...lesson,
  ...login,
  ...chat,
  ...chatbot,
  ...page,
  ...skills,
  ...timetable,
  ...trainingCourse,
  ...triad,
  ...platform,
  ...admin,
  ...studeaManager,
  ...dashboard,
  ...global,
  ...error,
  ...notepad,
  ...registration,
  ...training,
  ...institution,
  ...matching,
  ...landing,
  ...mailStatus,
};
